import React, { useState } from "react";
import { Table, Form, Dropdown, Button } from "react-bootstrap";
import { FiEdit2, FiTrash2 } from "react-icons/fi";


import DesignationHeader from "../../../components/hrm/employees/DesignationHeader";
import DeleteDesignationModal from "../../../components/modals/hrm/employee/designation/DeleteDesignationModal";
import EditDesignationModal from "../../../components/modals/hrm/employee/designation/EditDesignationModal";

const initialData = [
  { name: "Accountant", dept: "Finance", emp: 10, status: "Active" },
  { name: "App Developer", dept: "Application Development", emp: 15, status: "Active" },
  { name: "Technician", dept: "IT Management", emp: 8, status: "Active" },
  { name: "Web Developer", dept: "Web Development", emp: 10, status: "Active" },
  { name: "Sales Executive Officer", dept: "Sales", emp: 10, status: "Active" },
  { name: "Designer", dept: "UI / UX", emp: 15, status: "Active" },
  { name: "Account Manager", dept: "Account Management", emp: 8, status: "Active" },
  { name: "SEO Analyst", dept: "Marketing", emp: 10, status: "Inactive" },
  { name: "Admin", dept: "Administration", emp: 5, status: "Active" },
  { name: "Business Analyst", dept: "Business Development", emp: 7, status: "Active" },
];

export default function DesignationsPage() {
  const [data] = useState(initialData);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  const handleEdit = (row) => {
    setSelectedRow(row);
    setShowEdit(true);
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDelete(true);
  };

  return (
 <div style={{ padding: "15px", background: "#f8f9fa",  }}   >
     <DesignationHeader/>
        <div className="card custom-card mt-2">
      {/* HEADER */}
      <div style={{background:'#ffffff'}}  className="card-header d-flex justify-content-between flex-wrap">
        <h5 className="fw-semibold">Designation List</h5>

        <div className="d-flex gap-2 flex-wrap">
          <Dropdown>
            <Dropdown.Toggle className="rounded rounded-2 text-dark bg-white border border-1">Department</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>Finance</Dropdown.Item>
              <Dropdown.Item>Application Development</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown>
            <Dropdown.Toggle className="rounded rounded-2 text-dark bg-white border border-1">Select Status</Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>Active</Dropdown.Item>
              <Dropdown.Item>Inactive</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>

          <Dropdown>
            <Dropdown.Toggle className="rounded rounded-2 text-dark bg-white border border-1">
              Sort By : Last 7 Days
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item>Recently Added</Dropdown.Item>
              <Dropdown.Item>Ascending</Dropdown.Item>
              <Dropdown.Item>Descending</Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>

      {/* TABLE */}
      <div className="table-responsive">
        <Table className="mb-0 align-middle">
          <thead className="thead-light">
            <tr>
              <th><Form.Check /></th>
              <th>Designation</th>
              <th>Department</th>
              <th>No of Employees</th>
              <th>Status</th>
              <th></th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                <td><Form.Check /></td>

                <td className="fw-medium">{item.name}</td>

                <td>{item.dept}</td>

                <td>{item.emp.toString().padStart(2, "0")}</td>

                <td>
                  <span className={`badge-custom ${item.status === "Active" ? "active" : "inactive"}`}>
                    ● {item.status}
                  </span>
                </td>

                <td>
                  <div className="d-flex gap-2">
                    <FiEdit2 className="action-icon"
                      onClick={() => handleEdit(item)}
                    />
                    <FiTrash2 className="action-icon"
                      onClick={() => handleDelete(item)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>

      {/* MODALS */}
      <EditDesignationModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        data={selectedRow}
      />

      <DeleteDesignationModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
      />
    </div>
    <style>
     {
          `
          .custom-card {
  border-radius: 6px;
  border: 1px solid #e5e7eb;
}

/* dropdown buttons */
.btn-white {
  background: #fff;
  border: 1px solid #e5e7eb;
  color: #111;
  font-size: 14px;
}

/* status badges */
.badge-custom {
  padding: 5px 10px;
  border-radius: 6px;
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
}

.badge-custom.active {
  background: #22c55e;
  color: white;
}

.badge-custom.inactive {
  background: #ef4444;
  color: white;
}

/* icons */
.action-icon {
  cursor: pointer;
  font-size: 16px;
  color: #6b7280;
}

.action-icon:hover {
  color: #111;
}

/* orange button */
.btn-orange {
  background: #f97316;
  border: none;
}

.btn-orange:hover {
  background: #ea580c;
}

/* MOBILE */
@media (max-width: 768px) {
  .card-header {
    flex-direction: column;
    gap: 10px;
  }

  .table {
    font-size: 13px;
  }
}`
     }
    </style>
 </div>
  );
}